import "./styles/experience.css";
import Helmet from "react-helmet";
import INFO from "../data/user";
import SEO from "../data/seo";
import experience from "../data/experience";
import Timeline from "../components/experience/Timeline";

const Experience = () => {
	const currentSEO = SEO.find((item) => item.page === "experience");

	return (
		<>
			<Helmet>
				<title>{`Experience | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content experience-page">
				<div className="content-wrapper">
					<div className="experience-container">
						<div className="experience-eyebrow">● WORK HISTORY</div>
						<div className="title experience-title">
							Work History Overview
						</div>
						<Timeline entries={experience} />
					</div>
				</div>
			</div>
		</>
	);
};

export default Experience;
